import emojiMartData from '@emoji-mart/data';
import type { EmojiMartData } from '@emoji-mart/data';
import { EmojiInputPlugin, EmojiPlugin } from '@platejs/emoji/react';

import { EmojiInputElement } from 'src/components/ui/editor/ui/emoji-node';

export const EmojiKit = [
  EmojiPlugin.configure({
    // @emoji-mart/data's typings declare the data's shape but not its default export.
    options: { data: emojiMartData as unknown as EmojiMartData },
  }),
  EmojiInputPlugin.withComponent(EmojiInputElement),
];
